import { SVGAttributes } from 'react';

export const SearchIcon = ({ className, ...rootProps }: SVGAttributes<SVGSVGElement> & { show?: boolean }) => {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            {...rootProps}
            className={className}
            viewBox="0 0 20 20"
            fill="none"
        >
            <g clipPath="url(#clip0_11103_187)">
                <path d="M4 8H6C6 6.897 6.897 6 8 6V4C5.794 4 4 5.794 4 8Z" fill="#ADABAB" />
                <path d="M20 18.585L14.312 12.897C15.366 11.542 16 9.846 16 8C16 3.589 12.411 0 8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C9.846 16 11.543 15.366 12.898 14.312L18.585 20L20 18.585ZM8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14Z" fill="#ADABAB" />
            </g>
            <defs>
                <clipPath id="clip0_11103_187">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

SearchIcon.displayName = 'SearchIcon';



